import { render } from "./RandomNumber.vue?vue&type=template&id=60ee79a3"
import script from "./RandomNumber.vue?vue&type=script&lang=js"
export * from "./RandomNumber.vue?vue&type=script&lang=js"

import "./RandomNumber.vue?vue&type=style&index=0&id=60ee79a3&lang=css"

import exportComponent from "C:\\Users\\Melissa\\Desktop\\lifehack\\lifehack\\lifehack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__